// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"adf3e72e","359":"55471ece","405":"0e89608d","641":"4e4413a1","715":"88554e07","933":"1e1c2395"}[chunkId] + ".css";
};